import React, { useMemo } from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { AccountProfile } from "./pages/AccountProfile";
import { AccountProfileDetail } from "./pages/AccountProfileDetail";
import { useAccountUIContext } from "./AccountUIContext";

export function AccountUICard() {
  return (
    <>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 8,
        }}
      >
        <Container maxWidth="lg">
          <h1 className="pages-title">
            <u>Akun</u>
          </h1>
          <Grid container spacing={3}>
            <Grid item lg={4} md={6} xs={12}>
              <AccountProfile />
            </Grid>
            <Grid item lg={8} md={6} xs={12}>
              <AccountProfileDetail />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}
